<template>
  <!-- <div class="page-header " :class="{'card-base card-shadow--small':card, 'header-accent' : accent=='', 'header-primary' : accent=='primary'}"> -->
  <el-row class="page-header title">
    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
      <span>{{title}}</span>
    </el-col>

      <el-button style="position:relative;float:right" type="primary" v-if="showAddButton" size="small" @click="$emit('open')">{{btnTitle}}</el-button>

      <!-- <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/CMS/providers' }">{{title}}</el-breadcrumb-item>
        <el-breadcrumb-item>Nouveau producteur</el-breadcrumb-item>
      </el-breadcrumb> -->
      <!-- <div class="" v-if="showAddButton">
        <el-row>
           <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="text-right" >
             <el-button size="small" @click="$emit('open')">Ajouter</el-button>
           </el-col>
         </el-row>
      </div>
    </div> -->
  </el-row>
</template>
<script>

export default {
	name: 'Header-Card',
  props : {
    card : {
      type : Boolean,
      default : true
    },
    accent : {
      type : String,
      default : ''
    },
    title : {
      type : String,
      required : true
    },
    showAddButton : {
      type : Boolean,
      default : true
    },
    btnTitle : {
      type : String,
      default : "Ajouter"
    }
  },
	data() {
		return {}
	}
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables';
.page-header {
  margin-bottom: 10px;
}

.title {
	font-size : 1.6em;
	font-weight:bold;
	// margin-right:20px;
	position:relative;
	float:left;
}
</style>
